<template>
    <div>
        <div class="backfround">
            <img :src="loginConfig.userViewLoginBackground" alt="">
        </div>
        <div class="logo">
            <img :src="loginConfig.logo" alt="logo">
        </div>
        <div class="opreation">
            <p>设置密码</p>
            <mt-field placeholder="请输入密码" type="tel" v-model="userName"></mt-field>
            <p>确认密码</p>
            <mt-field placeholder="请确认密码" type="password" v-model="password"></mt-field>
            <span v-if="showPasswordError" class="error">两次密码输入不一致！</span>
            <span v-if="showError" class="error">请输入密码！</span>
            <div class="flex">
                <mt-button class="ignore" @click="$router.push('/school')">忽略</mt-button>
                <mt-button class="save" @click="save()">保存密码</mt-button>
            </div>
            <div class="mottoTitle">
                <p>{{ loginConfig.mottoTitle }}</p>
            </div>
            <div class="line"></div>
            <p class="bottom">{{ loginConfig.mottoContent }}</p>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { Toast } from 'mint-ui';

export default {
  name: 'ChangePassWord',
  meta:{page:true},
  watch: {
      errorMessage: function(val) {
        if (val !== '') {
            Toast({
                message: val,
                className: 'errorMessage'
            });
        }
    },
    successMessage: function(val) {
        if (val !== '') Toast(val);
    },
  },
  computed: {
        ... mapGetters('user', {
            loginConfig: 'getLoginConfig',
            errorMessage: 'getErrorMessage',
            successMessage: 'getSuccessMessage'
        })
  },
  data() {
    return {
        userName: '',
        password: '',
        showError: false,
        showPasswordError: false,
    }
  },
  created() {
      //this.$store.dispatch('user/loginInit');
  },
  methods: {
      loginCode: function() {
          this.$router.push('loginCode');
      },
      save: function() {
        if (this.password !== this.userName) {
            this.showPasswordError = true;
            return;
        } else {
            this.showPasswordError = false;
        }
        if (this.password.trim() === '' || this.userName.trim() === '') {
            this.showError = true;
            return;
        } else {
            this.showError = false;
        }
        this.$store.dispatch('user/setPassword', { passwd: this.userName })
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.flex {
    margin-top: 12px;
}
.ignore {
    font-size: .08rem;
    width: 100%;
    background: #ffffff;
    color: #009688;
    border: 1px solid #009688;
    margin-right: 8px;
    margin-bottom: 12px;
}
.error {
    color: red;
    padding-left: .1rem;
    margin-top: .05rem;
    display: inline-block;
}
.logo {
    position: absolute;
    top: 40px;
    left: 50%;
    transform: translate(-50%,0px);
}
.logo img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    border: 4px solid #fff;

}
.backfround img {
    width: 100%;
}
.opreation {
  /*width: calc(100% - 1.1rem);*/
    margin: .35rem;
    margin-bottom: 0;
    border-radius:0.1rem;
    box-shadow:0px 2px 5px 0px rgba(0,0,0,0.13);
    background: #FFFFFF;
    position: absolute;
    bottom: 20px;
    padding: 10px;
    padding-left: .2rem;
    padding-right: .2rem;
    padding-bottom: 0;
}
.opreation p {
    font-size: .16rem;
    padding: .1rem;
}
.opreation input {
    background: #f5f5f5 !important;
}
.forget {
    text-align: right;
    color: #009688;
    font-size: .13rem;
}
.mint-cell-wrapper {
    background: #f5f5f5 !important;
}
.save {
    width: 100%;
    background: #009688;
    color: #fff;
    margin-bottom: 12px;
}
.mottoTitle {
    text-align: center;
}
.mottoTitle p {
    display: inline-block;
    background: #fff;
    font-size: .12rem;
    color: #009688;
    text-align: center;
}
.line {
    height: 1px;
    background: #009688;
    margin-top: -.17rem;
}
.bottom {
    text-align: center;
    color: #7F7F7F;
    font-size: .12rem !important;
    margin-top: .24rem;
    margin-bottom: .2rem;
}
</style>




// WEBPACK FOOTER //
// src/components/page/ChangePassWord.vue